// Footer Component
import React from "react";

export default (loginpage) => {
  // Get Year Data
  const getYear = () => new Date().getFullYear();
  return (
    <>
      <footer className={`${loginpage.loginpage ? "position-relative login-footer" : "footer"}`}>
        <div className="container">
          <div className="text-center">
            Copyright &copy;
            {getYear()}
            <a href="https://www.whelen.com/" rel="noreferrer" target="_blank" className="d-inline-block mx-2">
              Whelen Engineering.
            </a>
            All rights reserved.
          </div>
        </div>
      </footer>
    </>
  );
};
